import { classes } from "../../nucleo/classes";

export interface ItemSegmentado<V extends string> {
  valor: V;
  rotulo: string;
}

export interface PropsDoSegmentado<V extends string> {
  rotulo: string;
  itens: ReadonlyArray<ItemSegmentado<V>>;
  valor: V;
  aoMudar: (valor: V) => void;
  className?: string;
}

/** O `.seg` do protótipo: escolha entre poucas alternativas mutuamente exclusivas. */
export function Segmentado<V extends string>({
  rotulo,
  itens,
  valor,
  aoMudar,
  className,
}: PropsDoSegmentado<V>) {
  return (
    <div className={classes("segmentado", className)} role="group" aria-label={rotulo}>
      {itens.map((item) => {
        const ativo = item.valor === valor;
        return (
          <button
            key={item.valor}
            type="button"
            aria-pressed={ativo}
            className={classes("segmentado__item", ativo && "segmentado__item--ativo")}
            onClick={() => aoMudar(item.valor)}
          >
            {item.rotulo}
          </button>
        );
      })}
    </div>
  );
}
